export interface Spc_data {
    id : number;

    imgurl : string;

    title : string;

    mos : string;

    persent : string;

    saleprice : string;

    price : string;
}

let spc_data:Spc_data[] = [
    {
        id : 33,

        imgurl : './img/special/img0.jpg',
        
        title : '멀티웨이 백팩 CJBG7405',

        mos : '30%',

        persent : '30%',

        saleprice : '55,800',

        price : '80,000'
    },
    {
        id : 34,
        
        imgurl : './img/special/img1.jpg',
        
        title : '올디네리 반팔티셔츠 옐로우 JIST7607',

        mos : '44%',

        persent : '44%',

        saleprice : '18,900',

        price : '33,900'
    },
    {
        id : 35,
        
        imgurl : './img/special/img2.jpg',
        
        title : '[패키지] 베리 카라 반팔티셔츠 2PACK KMST7598',

        mos : '52%',

        persent : '52%',

        saleprice : '35,700',

        price : '73,800'
    },
    {
        id : 36,
        
        imgurl : './img/special/img3.jpg',
        
        title : '미드썸머 스트라이프 반팔티셔츠 그레이 JIST7508',

        mos : '45%',

        persent : '45%',

        saleprice : '19,800',

        price : '35,900'
    },
    {
        id : 37,
        
        imgurl : './img/special/img4.jpg',
        
        title : '베리 카라 반팔티셔츠 네이비 KMST7598',

        mos : '32%',

        persent : '32%',

        saleprice : '25,000',

        price : '36,900'
    },
    {
        id : 38,
        
        imgurl : './img/special/img5.jpg',
        
        title : '팜트리 반팔티셔츠 네이비 JIST7503',

        mos : '37%',

        persent : '37%',

        saleprice : '16,900',

        price : '26,900'
    },
    {
        id : 39,
        
        imgurl : './img/special/img6.jpg',
        
        title : '팜트리 반팔티셔츠 네이비 JIST7503',

        mos : '37%',

        persent : '37%',

        saleprice : '16,900',

        price : '26,900'
    },
    {
        id : 40,
        
        imgurl : './img/special/img7.jpg',
        
        title : '럼블 코듀로이 팬츠 크림 CJLP7349',

        mos : '60%',

        persent : '60%',

        saleprice : '14,300',

        price : '35,900'
    },
    {
        id : 41,
        
        imgurl : './img/special/img8.jpg',
        
        title : '홀로그램 카라비너 키링 블랙 CJAC7337',

        mos : '59%',

        persent : '59%',

        saleprice : '4,900',

        price : '12,000'
    },
]

export default spc_data;